import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListBrandsLeasing from "../Components/Brands Leasing/listBrandsLeasing";
import AddBrandsLeasing from "../Components/Brands Leasing/addBrandsLeasing";
import EditBrandsLeasing from "../Components/Brands Leasing/editBrandsLeasing";
import ViewBrandsLeasing from "../Components/Brands Leasing/viewBrandsLeasing";

const BrandsLeasingRoutes = () => {
    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];

    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

    return (
        <Routes>
            <Route path="/brands_leasing" element={<ListBrandsLeasing />} />
            <Route
                path="/brands_leasing/add"
                element={canAdd ? <AddBrandsLeasing /> : <Navigate to="/brands_leasing" replace />}
            />
            <Route
                path="/brands_leasing/edit/:id"
                element={canEdit ? <EditBrandsLeasing /> : <Navigate to="/brands_leasing" replace />}
            />
            <Route
                path="/brands_leasing/view/:id"
                element={<ViewBrandsLeasing />}
            />
        </Routes>
    );
};

export default BrandsLeasingRoutes;